module.exports = __webpack_public_path__ + "static/media/sen_bon.94700e46.webp";